
export enum MemberEmailTypes {
    PrimaryEmail_UpdateInformation = 30,
    PrimaryEmailChange = 27,
    Password_Reset_link = 25,
    Password_Reset = 22
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-email-type.enum.ts